module.exports = __webpack_public_path__ + "img/page-detail-title1.09216ee6.png";